import { roles } from "constants/index";

export const rolesImport = [roles.admin, roles.areaManager]

export const rolesGetAllShop = [roles.admin, roles.qs, roles.regionManager, roles.viceRegionManager, roles.seniorAreaManager]

export const rolesExportMonthly = [roles.admin]